export const removeItemFromLocalStorage = (value) => {
    localStorage.removeItem(value)
}